/* Old Mountain Tea — client-side filtering for the "All teas" grid.
   Runs over the already-rendered product cards, so it works on a page
   template where Shopify's native faceting isn't available. Each card
   carries data-collections / data-place / data-oxidation / data-price;
   facet checkboxes carry data-group + value. A card is shown when it
   matches every active group (OR within a group, AND across groups). */
(function () {
  'use strict';

  function initFilter(root) {
    var grid = root.querySelector('.prods');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    var boxes = Array.prototype.slice.call(root.querySelectorAll('.side input[type="checkbox"][data-group]'));
    var countEl = root.querySelector('.allbar .count');
    var noRes = root.querySelector('.noresults');
    var clearBtn = root.querySelector('.clearall');
    var sortSel = root.querySelector('.sortsel');

    function cardMatches(card, active) {
      for (var group in active) {
        if (!active[group].length) continue;
        var ok = false;
        if (group === 'price') {
          var cents = parseInt(card.getAttribute('data-price') || '0', 10);
          ok = active[group].some(function (bucket) {
            if (bucket === 'u15') return cents < 1500;
            if (bucket === '15-25') return cents >= 1500 && cents < 2500;
            if (bucket === '25p') return cents >= 2500;
            return false;
          });
        } else if (group === 'place') {
          // "taiwan" matches every Taiwan card; "taiwan|Nantou" only that region.
          var place = (card.getAttribute('data-place') || '').toLowerCase();
          ok = active[group].some(function (v) {
            v = v.toLowerCase();
            return v.indexOf('|') === -1 ? place.indexOf(v + '|') === 0 : place === v;
          });
        } else if (group === 'type' || group === 'collection') {
          var handles = (card.getAttribute('data-collections') || '').split(' ');
          ok = active[group].some(function (v) { return handles.indexOf(v) !== -1; });
        } else {
          var attr = (card.getAttribute('data-' + group) || '').toLowerCase();
          ok = active[group].some(function (v) { return attr === v.toLowerCase(); });
        }
        if (!ok) return false;
      }
      return true;
    }

    function apply() {
      var active = {};
      boxes.forEach(function (b) {
        if (!b.checked) return;
        var g = b.getAttribute('data-group');
        (active[g] = active[g] || []).push(b.value);
      });
      var shown = 0;
      cards.forEach(function (card) {
        var vis = cardMatches(card, active);
        card.hidden = !vis;
        if (vis) shown++;
      });
      if (countEl) countEl.textContent = 'Showing ' + shown + (shown === 1 ? ' tea' : ' teas');
      if (noRes) noRes.hidden = shown !== 0;
    }

    function sort() {
      if (!sortSel) return;
      var mode = sortSel.value;
      var arr = cards.slice();
      arr.sort(function (a, b) {
        if (mode === 'newest') return num(b, 'data-created') - num(a, 'data-created');
        if (mode === 'price-asc') return num(a, 'data-price') - num(b, 'data-price');
        if (mode === 'price-desc') return num(b, 'data-price') - num(a, 'data-price');
        if (mode === 'title') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        return num(a, 'data-order') - num(b, 'data-order');
      });
      arr.forEach(function (c) { grid.appendChild(c); });
    }
    function num(el, attr) { return parseInt(el.getAttribute(attr) || '0', 10); }

    // Region: a country box ticks/unticks all its regions; picking only some
    // regions leaves the country indeterminate, so just those regions filter.
    function placeKids(country) {
      return boxes.filter(function (b) { return b.getAttribute('data-parent') === country; });
    }
    function placeParent(country) {
      return boxes.filter(function (b) {
        return b.getAttribute('data-group') === 'place' && !b.hasAttribute('data-parent') && b.value === country;
      })[0];
    }
    boxes.forEach(function (b) {
      if (b.getAttribute('data-group') !== 'place') return;
      var parent = b.getAttribute('data-parent');
      b.addEventListener('change', function () {
        if (!parent) {
          placeKids(b.value).forEach(function (k) { k.checked = b.checked; });
          b.indeterminate = false;
          return;
        }
        var p = placeParent(parent);
        if (!p) return;
        var kids = placeKids(parent);
        var on = kids.filter(function (k) { return k.checked; }).length;
        p.checked = on === kids.length;
        p.indeterminate = on > 0 && on < kids.length;
      });
    });
    root.querySelectorAll('.side .pl-tg').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (!sub) return;
        sub.hidden = !sub.hidden;
        btn.setAttribute('aria-expanded', sub.hidden ? 'false' : 'true');
      });
    });

    boxes.forEach(function (b) { b.addEventListener('change', apply); });
    if (sortSel) {
      sortSel.addEventListener('change', sort);
      // Apply the default sort ('Newest') on load — cards render in the
      // collection's server order, so reorder once to match the selection.
      sort();
    }
    if (clearBtn) clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      boxes.forEach(function (b) { b.checked = false; b.indeterminate = false; });
      apply();
    });

    // Collapse / expand a facet group by its header. The default open state is
    // responsive and lives in CSS: expanded on desktop (>=901px), collapsed on
    // mobile (<=900px). A user toggle sets an explicit class that wins within the
    // current breakpoint — `.collapsed` on desktop (default is open) and
    // `.expanded` on mobile (default is closed) — so each breakpoint reads only
    // its own override and the other layout keeps its default.
    var mqMobile = window.matchMedia('(max-width: 900px)');

    function isOpen(fg) {
      return mqMobile.matches
        ? fg.classList.contains('expanded')
        : !fg.classList.contains('collapsed');
    }

    root.querySelectorAll('.side .ft').forEach(function (ft) {
      ft.setAttribute('role', 'button');
      ft.setAttribute('tabindex', '0');

      function syncAria() {
        var fg = ft.closest('.fg');
        if (fg) ft.setAttribute('aria-expanded', isOpen(fg) ? 'true' : 'false');
      }

      function toggle() {
        var fg = ft.closest('.fg');
        if (!fg) return;
        if (mqMobile.matches) {
          fg.classList.toggle('expanded');
          fg.classList.remove('collapsed');
        } else {
          fg.classList.toggle('collapsed');
          fg.classList.remove('expanded');
        }
        syncAria();
      }

      syncAria();
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', syncAria);
      ft.addEventListener('click', toggle);
      ft.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.omt-filtered').forEach(initFilter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
